"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledToggleSwitchGroupLegend = exports.StyledToggleSwitchGroup = exports.StyledToggleSwitchGroupFieldset = void 0;
var styled_components_1 = require("styled-components");
var theme_1 = require("../../utils/theme");
var ApCheckLabel_1 = require("../../internal/ApCheckLabel");
exports.StyledToggleSwitchGroupFieldset = styled_components_1.default.fieldset({
    border: '0px',
    margin: '0px',
    minWidth: '0px',
    padding: '0px'
});
var getToggleSwitchGroupStyles = function (flexDirection) {
    var _a, _b, _c, _d, _e;
    var toggleSwitchGroupStyles = (_a = {},
        _a['row'] = (_b = {
                flexDirection: flexDirection
            },
            _b[":nth-child(n) > " + ApCheckLabel_1.StyledCheckLabel + ":not(:last-child)"] = {
                marginRight: theme_1.scaffolding.md
            },
            _b),
        _a['row-reverse'] = (_c = {
                flexDirection: flexDirection
            },
            _c[":nth-child(n) > " + ApCheckLabel_1.StyledCheckLabel + ":not(:first-child)"] = {
                marginRight: theme_1.scaffolding.md
            },
            _c),
        _a['column'] = (_d = {
                flexDirection: flexDirection
            },
            _d[":nth-child(n) > " + ApCheckLabel_1.StyledCheckLabel + ":not(:last-child)"] = {
                marginBottom: theme_1.scaffolding.md
            },
            _d),
        _a['column-reverse'] = (_e = {
                flexDirection: flexDirection
            },
            _e[":nth-child(n) > " + ApCheckLabel_1.StyledCheckLabel + ":not(:first-child)"] = {
                marginBottom: theme_1.scaffolding.md
            },
            _e),
        _a['default'] = {
            flexDirection: flexDirection
        },
        _a);
    return toggleSwitchGroupStyles[flexDirection]
        ? toggleSwitchGroupStyles[flexDirection]
        : toggleSwitchGroupStyles.default;
};
// Fieldset doesn't support flex properites as it's always supposed to be a verticle list
// https://stackoverflow.com/questions/28078681/why-cant-fieldset-be-flex-containers
exports.StyledToggleSwitchGroup = styled_components_1.default.div({
    display: 'flex'
}, function (_a) {
    var flexDirection = _a.flexDirection, justifyContent = _a.justifyContent;
    return (__assign(__assign({}, getToggleSwitchGroupStyles(flexDirection)), { justifyContent: justifyContent }));
});
exports.StyledToggleSwitchGroupLegend = styled_components_1.default.legend({
    display: 'none'
});
//# sourceMappingURL=styles.js.map